<template>
  <div class="partner">
    <div class="shadow"></div>
    <div class="certificate-list">
      <div class="certificate-list-left">
        <div class="toobar">
          <div class="eng">CERTIFICATE</div>
          <div class="eng-font">证书信息</div>
        </div>

        <ul>
          <li v-for="(item,index) in certificateItems">
            <div :class="cateIndex == item ? 'column2' : 'column1'" @click="showToggle(item)">
              {{item.name}}
              <span
                v-if="cateIndex == item"
                style="float: right; margin-right: 20px;"
              >></span>
            </div>
            <ul v-if="item.name=='发电集控运维'" v-show="isF">
              <li>
                <a @click="rdio(1)">
                  <div :class="radoFlag==1 ? 'rado1' : 'rado' ">初级</div>
                </a>
                <br />
                <a @click="rdio(2)">
                  <div :class="radoFlag==2 ? 'rado1' : 'rado' ">中级</div>
                </a>
                <br />
                <a @click="rdio(3)">
                  <div :class="radoFlag==3 ? 'rado1' : 'rado' ">高级</div>
                </a>
                <br />
              </li>
            </ul>
            <ul v-if="item.name=='垃圾焚烧发电'" v-show="isL">
              <li>
                <a @click="rdio(4)">
                  <div :class="radoFlag==4 ? 'rado1' : 'rado' ">初级</div>
                </a>
                <br />
                <a @click="rdio(5)">
                  <div :class="radoFlag==5 ? 'rado1' : 'rado' ">中级</div>
                </a>
                <br />
                <a @click="rdio(6)">
                  <div :class="radoFlag==6 ? 'rado1' : 'rado' ">高级</div>
                </a>
                <br />
              </li>
            </ul>
          </li>
        </ul>
        <br />
        <!-- <div class="column1">
          <div>考证信息</div>
        </div> -->
      </div>

      <div class="certificate-list-right">
        <div v-if="pindex==0" class="certificate-info">
          <div v-if="radoFlag <= 3" style="color: #0055D3;font-weight: bold;">
            <h2>发电集控运维职业技能等级证书{{rado[radoFlag-1].level}}</h2>
          </div>
          <div v-if="radoFlag >= 4" style="color: #0055D3;font-weight: bold;">
            <h2>垃圾焚烧发电运行与维护职业技能等级证书{{rado[radoFlag-1].level}}</h2>
          </div>
          <div
            v-if="radoFlag >= 4"
            style="margin: 28px 0;color: #333333; font-size: 14px;"
          >垃圾焚烧发电运行与维护职业技能等级证书由博努力（北京）仿真技术有限公司颁发。</div>

          <div
            v-if="radoFlag <= 3"
            style="margin: 28px 0;color: #333333; font-size: 14px;"
          >发电集控运维职业技能等级证书由博努力（北京）仿真技术有限公司颁发。</div>
          <div v-if="radoFlag <= 3" class="certificate-info-img1"></div>
          <div v-if="radoFlag >= 4" class="certificate-info-img"></div>
          <!-- 证书简介 适用人群 取证要求 对应要求 证书样本 （选项卡）-->
          <div class="certificate-info-menu">
            <ul>
              <li
                v-for="(item,index) in certificateList"
                :key="index"
                @click="certificate(index)"
                :class="certificateIndex== index ? 'certificate-menu-active' : 'certificate-menu-noactive'"
              >{{item}}</li>
            </ul>
          </div>
          <div class="hr"></div>
          <!-- 证书简介 -->
          <div
            v-if="certificateIndex==0 && radoFlag >= 4"
            class="certificate-info-content " style="white-space: pre-wrap;"
          >垃圾焚烧发电运行与维护职业技能等级证书对应的专业领域为能源与环境系统工程、能源与动力工程、生物质能应用技术、火电厂集控运行、电厂热能动力装置、热工自动化等相关专业，面向的{{rado[radoFlag-1].jianjie}}</div>
          <div
            v-if="certificateIndex==0 && radoFlag <= 3"
            class="certificate-info-content" style="white-space: pre-wrap;"
          >{{rado[radoFlag-1].jianjie}}</div>
          <!-- 适用人群 -->
          <div v-if="certificateIndex==1" class="certificate-info-content" style="white-space: pre-wrap;">
            <p>{{rado[radoFlag-1].renqun}}</p>
            <!-- <p>凡遵守国家法律法规，具备下列条件之一者，可以申请参加垃圾焚烧发电运行与维护（初级）考试：</p>
						<p>1、专业匹配的在校学生，完成垃圾焚烧发电运行与维护（初级）岗位相应课程学习的人员；</p>
						<p>2、参加完成垃圾焚烧发电运行与维护（初级）岗位培训的人员；</p>
            <p>3、垃圾焚烧发电运行与维护岗位工作一年以上且表现良好的从业人员。</p>-->
          </div>
          <!-- 取证要求 -->
          <div v-if="certificateIndex==2 && radoFlag >= 4 " class="certificate-info-content">
            <p>1、专业知识考核 垃圾焚烧发电运行与维护{{rado[radoFlag-1].level}}知识考核，满分100分，60分通过。</p>
            <p>2、职业技能考核 垃圾焚烧发电运行与维护{{rado[radoFlag-1].level}}技能考核，实操考核满分100分，60分通过。</p>
          </div>
          <div v-if="certificateIndex==2 && radoFlag <= 3 " class="certificate-info-content">
            <p>1、发电集控运维职业技能等级证书{{rado[radoFlag-1].level}}理论考核，满分100分，60分通过。</p>
            <p>2、发电集控运维职业技能等级证书{{rado[radoFlag-1].level}}实操考核，满分100分，60分通过。</p>
          </div>
          <!-- 对应要求 -->
          <div v-if="certificateIndex==3" class="certificate-info-content3">
            <table style="text-align: center;">
              <tr style="background: #0055D3;color: #FFFFFF;">
                <th width="140px">对应院校类型</th>
                <th width="140px">专业代码</th>
                <th width="510px">专业名称</th>
                <th width="140px">专业层次</th>
              </tr>
              <tr v-for="(item,index) in school" :key="index">
                <td>{{item.name}}</td>
                <td>{{item.code}}</td>
                <td>{{item.subject}}</td>
                <td>{{item.level}}</td>
              </tr>
            </table>
          </div>
          <!-- 证书样本 -->
          <div v-if="certificateIndex==4" class="certificate-info-content">
            <img
              v-if="radoFlag==4"
              width="960px"
              src="https://bernouly.oss-cn-beijing.aliyuncs.com/certificate/1_%E8%AF%81%E4%B9%A6%E6%A0%B7%E6%9C%AC-%E5%88%9D%E7%BA%A7.png"
              alt
            />
            <img
              v-if="radoFlag==5"
              width="960px"
              src="https://bernouly.oss-cn-beijing.aliyuncs.com/certificate/1_%E8%AF%81%E4%B9%A6%E6%A0%B7%E6%9C%AC-%E4%B8%AD%E7%BA%A7.png"
              alt
            />
            <img
              v-if="radoFlag==6"
              width="960px"
              src="https://bernouly.oss-cn-beijing.aliyuncs.com/certificate/1_%E8%AF%81%E4%B9%A6%E6%A0%B7%E6%9C%AC-%E9%AB%98%E7%BA%A7.png"
              alt
            />
            <img
              v-if="radoFlag==1"
              width="960px"
              src="https://bernouly.oss-cn-beijing.aliyuncs.com/certificate/fd_chuji.jpg"
              alt
            />
            <img
              v-if="radoFlag==2"
              width="960px"
              src="https://bernouly.oss-cn-beijing.aliyuncs.com/certificate/fd_zhongji.jpg"
              alt
            />
            <img
              v-if="radoFlag==3"
              width="960px"
              src="https://bernouly.oss-cn-beijing.aliyuncs.com/certificate/fd_gaoji.jpg"
              alt
            />
          </div>
        </div>
        <!-- 证书信息 翻页 -->
        <div v-if="certificateIndex == 3 && radoFlag <= 3" class="title-page">
          <div class="flex">
            <div
              class="box"
              :class="schoolIndex == 1 ? 'active' : ''"
              @click="certificatepagetap(1)"
            >1</div>
            <div
              class="box"
              :class="schoolIndex == 2 ? 'active' : ''"
              @click="certificatepagetap(2)"
            >2</div>
            <div
              class="box"
              :class="schoolIndex == 3 ? 'active' : ''"
              @click="certificatepagetap(3)"
            >3</div>
          </div>
          <div class="box title-page-active" @click="certificatepageto()" style="width: 150px;">下一页</div>
        </div>

        <div v-if="certificateIndex == 3 && radoFlag >= 4" class="title-page">
          <div class="flex">
            <div class="box" :class="schoolItem == 1? 'active' : ''" @click="catepagetap(1)">1</div>
            <div class="box" :class="schoolItem == 2 ? 'active' : ''" @click="catepagetap(2)">2</div>
            <div class="box" :class="schoolItem == 3 ? 'active' : ''" @click="catepagetap(3)">3</div>
            <div class="box" :class="schoolItem == 4 ? 'active' : ''" @click="catepagetap(4)">4</div>
          </div>
          <div class="box title-page-active" @click="catepageto()" style="width: 150px;">下一页</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  Article,
  ArChildren,
  timestampToTime,
  Serchdata,
} from "../../services/article";
export default {
  components: {},
  data() {
    return {
      activeName: 0,
      schoolIndex: 1,
      schoolItem: 1,
      school: [],
      cateIndex: 0,
      certificateIndex: 0,
      radoFlag: 1,
      pindex: 0,
      isF:false,
      isL:false,
      kg: false,
      /**
       * 一级分类子菜单
       * cate_id:分类子菜单id
       * name:分类子菜单名称
       * 测试数据 部署时清空
       */
      dataList: [],
      certificateList: [
        "证书简介",
        "适用人群",
        "取证要求",
        "对应要求",
        "证书样本",
      ],
      certificateItems: [
        {
          name: "发电集控运维",
          subItems: [
            {
              name: "初级",
            },
            {
              name: "中级",
            },
            {
              name: "高级",
            },
          ],
        },
        {
          name: "垃圾焚烧发电",
          subItems: [
            {
              name: "初级",
            },
            {
              name: "中级",
            },
            {
              name: "高级",
            },
          ],
        },
      ],
      rado: [
        {
          jianjie: "发电集控运维职业技能等级证书（初级）对应的专业领域：火电厂热力设备运行与检修、火电厂热力设备安装、火电厂热工仪表安装与检修、火电厂集控运行、发电厂及变电站电气设备、继电保护及自动装置调试维护等专业。\n面向的工作岗位群：发电企业、城市供热、大型企业动力车间或自备电厂集控运行巡检岗位。", 
          renqun:
            "凡遵守国家法律法规，具备下列条件之一者，可以申请参加发电集控运维职业技能等级证书（初级）考试：\n1.专业匹配的在校学生，完成发电集控运维初级相应课程学习的人员；\n2.参加完成发电集控运维职业技能等级证书初级培训的人员；\n3.发电集控运维岗位工作一年以上且表现良好的从业人员。",
          level: "（初级）",
        },
        {
          jianjie: "发电集控运维职业技能等级证书（中级）对应的专业领域：发电厂及电力系统、电力系统自动化技术、电厂热能动力装置、城市热能应用技术、火电厂集控运行、电厂热工自动化技术、电力系统继电保护及自动化技术、生物质能应用技术、工业节能技术、农村能源与环境技术等专业。\n面向的岗位群：发电企业、城市供热、大型企业动力车间或自备电厂集控运行副值（副控）岗位。", 
          renqun:
            "凡遵守国家法律法规，具备下列条件之一者，可以申请参加发电集控运维职业技能等级证书（中级）考试： \n1.专业匹配的高职及应用型本科在校学生，完成发电集控运维职业技能等级证书中级相应课程学习的人员；\n2.参加完成发电集控运维职业技能等级证书中级培训的人员；\n3.发电集控运维中级及以上岗位工作一年以上且表现良好的从业人员。",
          level: "（中级）",
        },
        {
          jianjie: "发电集控运维职业技能等级证书（高级）对应的专业领域：能源与动力工程、能源与环境系统工程、电气工程及其自动化专业、发电厂集控运行、热力设备检修、发电厂及变电站、热工自动化等相关专业。\n面向的岗位群：发电企业、城市供热、大型企业动力车间或自备电厂集控运行主值（主控）岗位。",
          renqun:
            "凡遵守国家法律法规，具备下列条件之一者，可以申请参加发电集控运维职业技能等级证书（高级）考试： \n1.专业匹配的应用型本科院校在校生，完成发电集控运维职业技能等级证书高级相应课程学习的人员。\n2.参加完成发电集控运维职业技能等级证书高级培训的人员；\n3.发电集控运维高级岗位工作一年以上且表现良好的从业人员。",
          level: "（高级）",
        },
        {
          jianjie:
            "垃圾焚烧发电运行与维护职业技能等级证书（初级）对应的专业领域：能源与环境系统工程、能源与动力工程、生物质能应用技术、火电厂集控运行、电厂热能动力装置、热工自动化等相关专业。\n面向的工作岗位群：垃圾、生物质焚烧发电机组集控运行巡检岗位。",
          renqun:
            "凡遵守国家法律法规，具备下列条件之一者，可以申请参加垃圾焚烧发电运行与维护（初级）考试： \n1.专业匹配的中职及以上在校学生，完成垃圾焚烧发电运行与维护初级相应课程学习的人员；\n2.参加完成垃圾焚烧发电运行与维护初级培训的人员；\n3.垃圾焚烧发电运行与维护岗位工作一年以上且表现良好的从业人员。",
          level: "（初级）",
        },
        {
          jianjie:
            "垃圾焚烧发电运行与维护职业技能等级证书（中级）对应的专业领域：能源与环境系统工程、能源与动力工程、生物质能应用技术、火电厂集控运行、电厂热能动力装置、热工自动化等相关专业。\n面向的岗位群：垃圾、生物质焚烧发电机组集控运行副值（副控）岗位。",
          renqun:
            "凡遵守国家法律法规，具备下列条件之一者，可以申请参加垃圾焚烧发电运行与维护（中级）考试：\n1.专业匹配的高职及应用型本科在校学生，完成垃圾焚烧发电运行与维护中级相应课程学习的人员；\n2.参加完成垃圾焚烧发电运行与维护中级培训的人员；\n3.垃圾焚烧发电运行与维护中级及以上岗位工作一年以上且表现良好的从业人员。",
          level: "（中级）",
        },
        {
          jianjie:
            "垃圾焚烧发电运行与维护职业技能等级证书（高级）对应的专业领域：能源与环境系统工程、能源与动力工程、生物质能应用技术、火电厂集控运行、电厂热能动力装置、热工自动化等相关专业。\n面向的岗位群：垃圾、生物质焚烧发电机组集控运行主值（主控）岗位。",
          renqun:
            "凡遵守国家法律法规，具备下列条件之一者，可以申请参加垃圾焚烧发电运行与维护（高级）考试：\n1.专业匹配的应用型本科院校在校生，完成垃圾焚烧发电运行与维护高级相应课程学习的人员。\n2.参加完成垃圾焚烧发电运行与维护高级培训的人员；\n3.垃圾焚烧发电运行与维护高级岗位工作一年以上且表现良好的从业人员。",
          level: "（高级）",
        },
      ],
      school1: [
        {
          name: "中职院校",
          code: "031600",
          subject: "继电保护及自动装置调试维护",
          level: "中专",
        },
        {
          name: "中职院校",
          code: "031500",
          subject: "发电厂及变电站电气设备",
          level: "中专",
        },
        {
          name: "中职院校",
          code: "030800",
          subject: "火电厂集控运行",
          level: "中专",
        },
        {
          name: "中职院校",
          code: "030700",
          subject: "火电厂热工仪表安装与检修",
          level: "中专",
        },
        {
          name: "中职院校",
          code: "030600",
          subject: "火电厂热力设备安装",
          level: "中专",
        },
        {
          name: "中职院校",
          code: "530204",
          subject: "火电厂热力设备运行与检修",
          level: "中专",
        },
        {
          name: "高职院校",
          code: "530308",
          subject: "农村能源与环境技术",
          level: "专科",
        },
        {
          name: "高职院校",
          code: "530303",
          subject: "生物质能应用技术",
          level: "专科",
        },
        {
          name: "高职院校",
          code: "530204",
          subject: "火电厂集控运行",
          level: "专科",
        },
        {
          name: "高职院校",
          code: "530305",
          subject: "工业节能技术",
          level: "专科",
        },
      ],
      school2: [
        {
          name: "高职院校",
          code: "530101",
          subject: "发电厂及电力系统",
          level: "专科",
        },
        {
          name: "高职院校",
          code: "530103",
          subject: "电力系统自动化技术",
          level: "专科",
        },
        {
          name: "高职院校",
          code: "530105",
          subject: "电力系统继电保护与自动化技术",
          level: "专科",
        },
        {
          name: "高职院校",
          code: "530201",
          subject: "电厂热能动力装置",
          level: "专科",
        },
        {
          name: "高职院校",
          code: "530206",
          subject: "能源与环境系统工程",
          level: "专科",
        },
        {
          name: "高职院校",
          code: "530202",
          subject: "能源与环境系统工程",
          level: "专科",
        },
        {
          name: "高职院校",
          code: "530102",
          subject: "供用电技术",
          level: "专科",
        },
        {
          name: "高职院校",
          code: "520804",
          subject: "环境工程技术",
          level: "专科",
        },
        {
          name: "本科院校",
          code: "080501",
          subject: "能源与动力工程",
          level: "本科",
        },
        {
          name: "本科院校",
          code: "080601",
          subject: "电气工程及其自动化",
          level: "本科",
        },
      ],
      school3: [
        {
          name: "本科院校",
          code: "080502T",
          subject: "能源与环境系统工程",
          level: "本科",
        },
        {
          name: "本科层次职业教育试点学校",
          code: "760302",
          subject: "电气工程及其自动化",
          level: "本科(职业教育试点)",
        },
        {
          name: "本科层次职业教育试点学校",
          code: "030700",
          subject: "新能源工程",
          level: "本科(职业教育试点)",
        },
      ],
      school4: [
        {
          name: "高职院校",
          code: "460204",
          subject: "新能源装备技术",
          level: "专科",
        },
        {
          name: "中职院校",
          code: "630203",
          subject: "火电厂热力设备运行与检修",
          level: "中专",
        },
        {
          name: "中职院校",
          code: "630201",
          subject: "火电厂热力设备安装",
          level: "中专",
        },
        {
          name: "中职院校",
          code: "630202",
          subject: "火电厂热工仪表安装与检修",
          level: "中专",
        },
        {
          name: "中职院校",
          code: "630204",
          subject: "火电厂集控运行",
          level: "中专",
        },
        {
          name: "高职院校",
          code: "430101",
          subject: "发电厂及电力系统",
          level: "专科",
        },
        {
          name: "高职院校",
          code: "430105",
          subject: "电力系统自动化技术",
          level: "专科",
        },
        {
          name: "高职院校",
          code: "430202",
          subject: "城市热能应用技术",
          level: "专科",
        },
        {
          name: "高职院校",
          code: "430208",
          subject: "电厂化学与环保技术",
          level: "专科",
        },
        {
          name: "高职院校",
          code: "430303",
          subject: "生物质能应用技术",
          level: "专科",
        },
      ],
      school5: [
        {
          name: "高职院校",
          code: "430305",
          subject: "工业节能技术",
          level: "专科",
        },
        {
          name: "高职院校",
          code: "460307",
          subject: "工业过程自动化技术",
          level: "专科",
        },
        {
          name: "高职院校",
          code: "430207",
          subject: "核电站动力设备运行与维护",
          level: "专科",
        },
        {
          name: "高职院校",
          code: "530105",
          subject: "电力系统继电保护与自动化技术",
          level: "专科",
        },
        {
          name: "高职院校",
          code: "560207",
          subject: "新能源装备技术",
          level: "专科",
        },
        {
          name: "本科院校",
          code: "080601",
          subject: "电气工程及其自动化",
          level: "本科",
        },
        {
          name: "本科院校",
          code: "080502T",
          subject: "能源与环境系统工程",
          level: "本科",
        },
        {
          name: "本科院校",
          code: "080501",
          subject: "能源与动力工程",
          level: "本科",
        },
        {
          name: "高职院校",
          code: "530202",
          subject: "城市热能应用技术",
          level: "专科",
        },
        {
          name: "中职院校",
          code: "030600",
          subject: "火电厂热力设备安装",
          level: "中专",
        },
      ],
      school6: [
        {
          name: "中职院校",
          code: "030700",
          subject: "火电厂热工仪表安装与检修",
          level: "中专",
        },
        {
          name: "中职院校",
          code: "030800",
          subject: "火电厂集控运行",
          level: "中专",
        },
        {
          name: "中职院校",
          code: "031500",
          subject: "发电厂及变电站电气设备",
          level: "中专",
        },
        {
          name: "中职院校",
          code: "031600",
          subject: "继电保护及自动装置调试维护",
          level: "中专",
        },
        {
          name: "高职院校",
          code: "530101",
          subject: "发电厂及电力系统",
          level: "专科",
        },
        {
          name: "高职院校",
          code: "530103",
          subject: "电力系统自动化技术",
          level: "专科",
        },
        {
          name: "高职院校",
          code: "530201",
          subject: "电厂热能动力装置",
          level: "专科",
        },
        {
          name: "中职院校",
          code: "030500",
          subject: "火电厂热力设备运行与检修",
          level: "中专",
        },
        {
          name: "高职院校",
          code: "530204",
          subject: "火电厂集控运行",
          level: "专科",
        },
        {
          name: "高职院校",
          code: "530206",
          subject: "电厂热工自动化技术",
          level: "专科",
        },
      ],
      school7: [
        {
          name: "高职院校",
          code: "530205",
          subject: "电厂化学与环保技术",
          level: "专科",
        },
        {
          name: "高职院校",
          code: "530303",
          subject: "生物质能应用技术",
          level: "专科",
        },
        {
          name: "高职院校",
          code: "530305",
          subject: "工业节能技术",
          level: "专科",
        },
        {
          name: "高职院校",
          code: "560303",
          subject: "工业过程自动化技术",
          level: "专科",
        },
        {
          name: "高职院校",
          code: "530203",
          subject: "核电站动力设备运行与维护",
          level: "专科",
        },
      ],
    };
  },
  mounted() {
    // this.menuClick();
  },
  watch: {},
  created() {},
  methods: {
    showToggle: function (item) {
      // 控制菜单显隐
      if(item.name == "发电集控运维"){
        this.rdio(1);
        this.isL = false;
        this.isF = true;
      }else{
        this.rdio(4);
        this.isF = false;
        this.isL = true;
      }
      if (this.cateIndex = item) {
        item.isSubShow = !item.isSubShow;
      }
    },
    //   证书信息 显示学校信息
    certificate(index) {
      if (index == 3) {
        this.school = this.school1;
      }
      this.certificateIndex = index;
    },
    //证书信息-对应要求-翻页
    certificatepagetap(n) {
      if (n == 1) {
        this.schoolIndex = 1;
        this.school = this.school1;
      } else if (n == 2) {
        this.schoolIndex = 2;
        this.school = this.school2;
      } else {
        this.schoolIndex = 3;
        this.school = this.school3;
      }
    },

    catepagetap(n) {
      if (n == 1) {
        this.schoolItem = 1;
        this.school = this.school4;
      } else if (n == 2) {
        this.schoolItem = 2;
        this.school = this.school5;
      } else if (n == 3) {
        this.schoolItem = 3;
        this.school = this.school6;
      } else {
        this.schoolItem = 4;
        this.school = this.school7;
      }
    },

    certificatepageto() {
      if (this.schoolIndex == 1) {
        this.schoolIndex = 2;
        this.school = this.school2;
      } else if (this.schoolIndex == 2) {
        this.schoolIndex = 3;
        this.school = this.school3;
      } else if (this.schoolIndex == 3) {
        this.schoolIndex = 1;
        this.school = this.school1;
      }
    },
    catepageto() {
      if (this.schoolItem == 1) {
        this.schoolItem = 2;
        this.school = this.school5;
      } else if (this.schoolItem == 2) {
        this.schoolItem = 3;
        this.school = this.school6;
      } else if (this.schoolItem == 3) {
        this.schoolItem = 4;
        this.school = this.school7;
      } else if (this.schoolItem == 4) {
        this.schoolItem = 1;
        this.school = this.school4;
      }
    },
    //证书信息-对应要求-下一页
    kgc() {
      if (this.kg) {
        this.kg = false;
      } else {
        this.kg = true;
      }
    },

    //初中高级证书简介--切换
    rdio(index) {
      this.radoFlag = index;
      //重置对应要求,高校代码
      this.schoolIndex = 1;
      this.school = this.school1;
      //重置主体内容介绍标签
      this.certificateIndex = 0;
    },
  },
};
</script>
<style>
.partner {
  background-color: white;
}
.certificate-list {
  width: 1200px;
  min-height: 450px;
  margin: 0 auto;
}
.certificate-list-left {
  float: left;
  width: 185px;
}
.toobar {
  height: 78px;
  padding-top: 30px;
  border-bottom: 1px solid #6d5c55;
}

.eng {
  font-size: 16px;
  color: #666666;
}

.eng-font {
  font-size: 26px;
}

.column1 {
  height: 52px;
  width: auto;
  font-size: 14px;
  font-weight: Bold;
  border-bottom: 1px solid #d4d4d4;
  padding-left: 10px;
  line-height: 52px;
  font-family: "Microsoft YaHei";
  display: flex;
  justify-content: space-between;
}
.column2 {
  height: 52px;
  width: auto;
  font-size: 14px;
  font-weight: Bold;
  border-bottom: 1px solid #d4d4d4;
  padding-left: 10px;
  line-height: 52px;
  color: #0055d3;
  font-family: "Microsoft YaHei";
  display: flex;
  justify-content: space-between;
}
.column1:hover,
.column2:hover {
  color: #0055d3;
  cursor: pointer;
}
.certificate-list-right {
  position: relative;
  display: inline-block !important;
  width: 1014px;
  height: auto;
  border-left: 1px solid #d4d4d4;
}
.certificate-info {
  min-height: 450px;
  margin-top: 50px;
  margin-left: 50px;
}
.certificate-menu {
  width: 1190px;
  background: #fff;
  position: absolute;
  top: 410px;
  height: 80px;
  left: 50%;
  margin-left: -600px;
}
.rado {
  height: 30px;
  display: inline-block;
  margin-left: 10px;
  background: url(../../assets/xuanzhzong_1.png) no-repeat 12px 12px;
  line-height: 34px;
  padding-left: 30px;
  margin-left: 0px;
  font-size: 15px;
}

.rado1 {
  height: 30px;
  display: inline-block;
  margin-left: 10px;
  background: url(../../assets/xuanzhong.png) no-repeat 12px 12px;
  line-height: 34px;
  padding-left: 30px;
  margin-left: 0px;
  font-size: 15px;
}
.certificate-info-img {
  width: 100%;
  height: 292px;
  background-image: url(http://bernouly.oss-cn-beijing.aliyuncs.com/1%2BX/zhengshu.png);
}
.certificate-info-img1 {
  width: 100%;
  height: 292px;
  background-image: url(https://bernouly.oss-cn-beijing.aliyuncs.com/certificate/fadianjikong_bg.png);
}
.certificate-info-menu {
  color: #666666;
  height: 80px;
}

.certificate-info-menu ul {
  display: flex;
}

.certificate-info-menu li {
  width: 100px;
  cursor: pointer;
  height: 80px;
  font-size: 16px;
  text-align: center;
  line-height: 80px;
}

.hr {
  height: 4px;
  background: #ededed;
}

.certificate-info-content {
  line-height: 30px;
  margin-top: 40px;
  margin-bottom: 100px;
  color: #666666;
}

.certificate-info-content3 {
  margin-top: 40px;
  height: 574px;
  color: #666666;
}

.certificate-info-content3 tr {
  height: 50px;
  background: #eaf2ff;
}

.certificate-info-content3 tr:nth-child(2n + 1) {
  background: #fafafa;
}

.kai {
  transform: rotate(-90deg);
}
.title-page .box {
  width: 60px;
  height: 60px;
  text-align: center;
  line-height: 60px;
  margin-right: 2px;
  font-size: 16px;
  color: #333;
  background: #ddd;
}
.shadow {
  height: 100px;
  width: 100%;
  background-color: #d7d7d7;
}
.box:hover {
  cursor: pointer;
}

.title-page .flex {
  display: flex;
}

.title-page .active {
  color: #fff;
  background: #0055d3;
}

.title-page-active:active {
  background: #0055d3;
  color: #fff;
}
</style>